import React, { Component } from "react";
import { logout } from "../../../lib/logout";
import commonFunction from "../../../lib/utils/common";
import { getBalance } from "../../../lib/login";
export default class Header10 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDropdown: null,
      servicesDropdownItems: [],
      quickLinksDropdownItems: [
        {
          label: "Agency Profile",
          url: "/myprofile?activeTab=agencyprofile",
          code: "agency_profile",
        },
        {
          label: "Payment Receipts",
          url: "/myprofile?activeTab=paymentreceipt",
          code: "payment_receipts",
        },
        {
          label: "Feedback",
          url: "/myprofile?activeTab=feedback",
          code: "feedback",
        },
        {
          label: "Manage Staff",
          url: "/myprofile?activeTab=managestaff",
          code: "manage_staff",
        },
        {
          label: "Bank Details",
          url: "/myprofile?activeTab=bankdetails",
          code: "bank_details",
        },
        {
          label: "Settings",
          url: "/myprofile?activeTab=settings",
          code: "settings",
        },
      ],
      currencyList: [],
      currency: "",
      showBalance: false,
      showProfile: false,
      availableBalance: { creditAmount: 0, balanceAmount: 0, usedAmount: 0 },
      isLoadingBalance: false,
      balanceError: false,
    };
    this.ref = React.createRef();
    this.profileRef = React.createRef();
    this.balancePopupRef = React.createRef();
  }

  capitalize(name) {
    return name
      ?.toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  componentDidMount() {
    this.fetchServices();
    const currencyData = [this.props?.data?.user?.org_dtls?.default_currency];
    if (this.props?.data?.user?.org_dtls?.secondary_currency) {
      currencyData.push(this.props.data.user.org_dtls.secondary_currency);
    }
    this.setState(
      {
        currencyList: currencyData,
        currency: this.props?.data?.user?.org_dtls?.default_currency,
      },
      () => this.getAvailableBalance()
    );
    document.addEventListener("mousedown", this.handleDocumentClick);
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocumentClick);
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleOutsideClick = (event) => {
    if (this.ref.current && !this.ref.current.contains(event.target)) {
      this.setState({
        activeDropdown: null,
        showBalance: false,
        showProfile: false,
      });
    }
  };

  handleClickOutside = (event) => {
    if (
      this.profileRef.current &&
      !this.profileRef.current.contains(event.target)
    ) {
      this.setState({ showProfile: false });
    }
  };

  handleDocumentClick = (event) => {
    if (
      this.state.showBalance &&
      this.balancePopupRef.current &&
      !this.balancePopupRef.current.contains(event.target) &&
      !event.target.closest('[class*="header__balance"]')
    ) {
      this.setState({ showBalance: true });
    }
    if (
      this.state.showProfile &&
      this.profileRef.current &&
      !this.profileRef.current.contains(event.target) &&
      !event.target.closest('[class*="header__greeting"]')
    ) {
      this.setState({ showProfile: false });
    }
  };

  handleBalanceModal = (event) => {
    if (
      this.balancePopupRef.current &&
      !this.balancePopupRef.current.contains(event.target)
    ) {
      this.setState({ showBalance: true });
    }
  };

  fetchServices = async () => {
    try {
      const activeServices =
        this.props.data?.headermenu?.menu
          .filter((item) => item.status.toLowerCase() === "active")
          .map((item) => ({
            ...item,
            label: item.text,
          })) || [];
      this.setState({ servicesDropdownItems: activeServices });
    } catch (error) {
      console.error("Error fetching services", error);
    }
  };

  DropIcon = () => (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.74679 0.770173L0.775391 1.74158L6.26355 7.22974L11.7517 1.74158L10.7803 0.770173L6.26355 5.28693L1.74679 0.770173Z"
        fill="#54627B"
      />
    </svg>
  );

  toggleDropdown = (dropdown) => {
    this.setState((prevState) => ({
      activeDropdown: prevState.activeDropdown === dropdown ? null : dropdown,
      showBalance: false,
      showProfile: false,
    }));
  };

  mouseLeave = () => {
    this.setState((prevState) => ({
      activeDropdown: null,
      showBalance: false,
      showProfile: false,
    }));
  };

  handleNavigation = (url) => {
    window.location.href = url;
  };

  getAvailableBalance = async () => {
    this.setState({ isLoadingBalance: true });
    try {
      const response = await getBalance();
      if (response && response?.status === true) {
        let availableBalance = response || null;
        this.setState({ isLoadingBalance: false });
        let creditAmount = 0;
        let balanceAmount = 0;
        let usedAmount = 0;
        if (
          availableBalance &&
          availableBalance?.data &&
          Array.isArray(availableBalance?.data)
        ) {
          const selectedCurrencyData = availableBalance?.data.find(
            (item) =>
              item.credit_limit_summary?.currency === this.state.currency
          );

          if (
            selectedCurrencyData &&
            selectedCurrencyData.credit_limit_summary
          ) {
            creditAmount =
              selectedCurrencyData.credit_limit_summary.total_credit_limit || 0;
            balanceAmount =
              selectedCurrencyData.credit_limit_summary.available_balance || 0;
            usedAmount =
              selectedCurrencyData.credit_limit_summary.total_due_amount || 0;
          } else {
            creditAmount = 0;
            balanceAmount = 0;
            usedAmount = 0;
          }

          this.setState({
            availableBalance: {
              creditAmount,
              balanceAmount,
              usedAmount,
            },
          });
        }
      } else {
        this.setState({ isLoadingBalance: false });
        console.error("Failed to fetch balance", response.message);
      }
    } catch (error) {
      this.setState({ isLoadingBalance: false });

      console.error("Error fetching balance", error);
    }
  };

  renderNavItem = (item) => {
    const { cssfile } = this.props.data;
    return (
      <div
        key={item.label}
        className={cssfile["header__quick-links"]}
        onClick={() => item.isDropdown && this.toggleDropdown(item.label)}
        // onMouseEnter={() => item.isDropdown && this.toggleDropdown(item.label)}
        onMouseLeave={() => item.isDropdown && this.mouseLeave()}
      >
        {item.isDropdown ? (
          <>
            <span className={cssfile["header__nav-item"]}>{item.label}</span>
            <this.DropIcon />
            {this.state.activeDropdown === item.label && (
              <div className={cssfile["dropdown"]}>
                {item.dropdownItems.map((dropdownItem, index) => {
                  const isActive =
                    item.label == "Services" &&
                    dropdownItem.url == window.location.pathname;
                  return (
                    <div
                      key={index}
                      className={[
                        cssfile["dropdown-item"],
                        cssfile[isActive ? "active-service" : ""],
                      ].join(" ")}
                      onClick={() => this.handleNavigation(dropdownItem.url)}
                    >
                      <span className={cssfile["dropdown-item-icon"]}>
                        <img
                          src={
                            item.label == "Services"
                              ? "/shared/api/media/" +
                                this.props.data.site_id +
                                "/" +
                                dropdownItem.icon
                              : `/images/${dropdownItem.code}_icon.svg`
                          }
                          alt={`${dropdownItem.code} icon`}
                        />
                      </span>
                      <span className={cssfile["dropdown-item-label"]}>
                        {dropdownItem.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ) : (
          <span
            className={cssfile["header__nav-item"]}
            onClick={() => this.handleNavigation(item.url)}
          >
            {item.label}
          </span>
        )}
      </div>
    );
  };

  handleCurrencySelect = (event, item) => {
    event.stopPropagation();
    this.setState({ currency: item, showBalance: true }, () => {
      this.getAvailableBalance();
    });
  };

  renderBalance = () => {
    const { cssfile } = this.props.data;
    const { balanceError } = this.state;
    return (
      <>
        {!balanceError && (
          <div
            id="balance-modal"
            className={cssfile["check_balance"]}
            ref={this.balancePopupRef}
          >
            <div className={cssfile["check_balance_label"]}>
              <span className={cssfile["check_balance_label_text"]}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M3.33331 12.0007V12.6673V3.33398V12.0007ZM3.53848 13.6673C3.20604 13.6673 2.92204 13.5496 2.68648 13.3142C2.45104 13.0786 2.33331 12.7946 2.33331 12.4622V3.53915C2.33331 3.20671 2.45104 2.92271 2.68648 2.68715C2.92204 2.45171 3.20604 2.33398 3.53848 2.33398H12.4615C12.7939 2.33398 13.0779 2.45171 13.3135 2.68715C13.5489 2.92271 13.6666 3.20671 13.6666 3.53915V5.35332H12.6666V3.53915C12.6666 3.47926 12.6474 3.4301 12.609 3.39165C12.5705 3.35321 12.5214 3.33398 12.4615 3.33398H3.53848C3.47859 3.33398 3.42942 3.35321 3.39098 3.39165C3.35254 3.4301 3.33331 3.47926 3.33331 3.53915V12.4622C3.33331 12.522 3.35254 12.5712 3.39098 12.6096C3.42942 12.6481 3.47859 12.6673 3.53848 12.6673H12.4615C12.5214 12.6673 12.5705 12.6481 12.609 12.6096C12.6474 12.5712 12.6666 12.522 12.6666 12.4622V10.648H13.6666V12.4622C13.6666 12.7946 13.5489 13.0786 13.3135 13.3142C13.0779 13.5496 12.7939 13.6673 12.4615 13.6673H3.53848ZM8.87181 11.0007C8.53937 11.0007 8.25537 10.8829 8.01981 10.6475C7.78437 10.4119 7.66665 10.1279 7.66665 9.79548V6.20582C7.66665 5.87337 7.78437 5.58937 8.01981 5.35382C8.25537 5.11837 8.53937 5.00065 8.87181 5.00065H13.1281C13.4606 5.00065 13.7446 5.11837 13.9801 5.35382C14.2156 5.58937 14.3333 5.87337 14.3333 6.20582V9.79548C14.3333 10.1279 14.2156 10.4119 13.9801 10.6475C13.7446 10.8829 13.4606 11.0007 13.1281 11.0007H8.87181ZM13.1281 10.0007C13.188 10.0007 13.2372 9.98143 13.2756 9.94298C13.3141 9.90454 13.3333 9.85537 13.3333 9.79548V6.20582C13.3333 6.14593 13.3141 6.09676 13.2756 6.05832C13.2372 6.01987 13.188 6.00065 13.1281 6.00065H8.87181C8.81192 6.00065 8.76276 6.01987 8.72431 6.05832C8.68587 6.09676 8.66665 6.14593 8.66665 6.20582V9.79548C8.66665 9.85537 8.68587 9.90454 8.72431 9.94298C8.76276 9.98143 8.81192 10.0007 8.87181 10.0007H13.1281ZM10.6666 9.00065C10.9444 9.00065 11.1805 8.90343 11.375 8.70898C11.5694 8.51454 11.6666 8.27843 11.6666 8.00065C11.6666 7.72287 11.5694 7.48676 11.375 7.29232C11.1805 7.09787 10.9444 7.00065 10.6666 7.00065C10.3889 7.00065 10.1528 7.09787 9.95831 7.29232C9.76387 7.48676 9.66665 7.72287 9.66665 8.00065C9.66665 8.27843 9.76387 8.51454 9.95831 8.70898C10.1528 8.90343 10.3889 9.00065 10.6666 9.00065Z"
                    fill="white"
                  ></path>
                </svg>
                {"Check Balance"}
              </span>
              <span onClick={this.handleBalanceModal}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
            <div className={cssfile["currency_selection"]}>
              {this.state.currencyList.map((item, index) => (
                <div
                  className={cssfile["currency_selection_item"]}
                  key={index}
                  onClick={(e) => this.handleCurrencySelect(e, item)}
                >
                  <input
                    type="radio"
                    name="currency"
                    value={item}
                    id={item}
                    checked={item == this.state.currency}
                    // onChange={(e) => this.handleCurrencySelect(e)}
                  />
                  <span className={cssfile["currency"]}>{item}</span>
                </div>
              ))}
            </div>

            {this.state.isLoadingBalance ? (
              <>
                <div className={cssfile["credit_amount"]}>
                  <div className={cssfile["skeleton_wrapper"]}>
                    <div className={cssfile["flex_rowjustify"]}>
                      <div className={cssfile["skeleton_text70"]}></div>
                      <div className={cssfile["skeleton_text30"]}></div>
                    </div>
                    <div className={cssfile["flex_rowjustify"]}>
                      <div className={cssfile["skeleton_text70"]}></div>
                      <div className={cssfile["skeleton_text30"]}></div>
                    </div>
                    <div className={cssfile["flex_rowjustify"]}>
                      <div className={cssfile["skeleton_text70"]}></div>
                      <div className={cssfile["skeleton_text30"]}></div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={cssfile["credit_amount"]}>
                  <span className={cssfile["credit_amount_label"]}>
                    {"Credit Amount:"}
                  </span>
                  <span className={cssfile["credit_amount_value"]}>
                    {this.state.availableBalance?.creditAmount}
                  </span>
                </div>
                <div className={cssfile["balance_amount"]}>
                  <span className={cssfile["credit_amount_label"]}>
                    {"Balance Amount:"}
                  </span>
                  <span className={cssfile["credit_amount_value"]}>
                    {this.state.availableBalance?.balanceAmount}
                  </span>
                </div>
                <div className={cssfile["used_amount"]}>
                  <span className={cssfile["credit_amount_label"]}>
                    {"Used Amount:"}
                  </span>
                  <span className={cssfile["credit_amount_value"]}>
                    {this.state.availableBalance?.usedAmount}
                  </span>
                </div>
              </>
            )}
          </div>
        )}

        {balanceError && (
          <div
            id="balance-modal"
            className={`${cssfile["check_balance"]} ${cssfile["check_balance_error"]}`}
            ref={this.balancePopupRef}
          >
            <span
              onClick={this.handleBalanceModal}
              className={cssfile["error_close"]}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
                  fill="black"
                />
              </svg>
            </span>
            <div
              className={cssfile["error_noresultfound"]}
              role="alert"
              aria-live="polite"
            >
              <div className={cssfile["error_noresultfound__content"]}>
                <h2 className={cssfile["error_noresultfound__title"]}>
                  We're experiencing a temporary issue retrieving your wallet
                  balance.
                </h2>
                <p className={cssfile["error_noresultfound__subtitle"]}>
                  Your funds are safe.
                </p>
                {/* <p className={cssfile['error_noresultfound__subtitle']}>Thanks for your understanding - stay tuned for an enhanced experience!</p> */}
                <button
                  className={cssfile["error_noresultfound__button"]}
                  onClick={() => {
                    this.getAvailableBalance();
                  }}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  handleBalanceModal = () => {
    this.setState({
      showBalance: !this.state.showBalance,
      activeDropdown: null,
      showProfile: false,
    });
  };

  logOutFun = () => {
    logout().then((res) => {
      if (res && res.status) {
        this.handleNavigation("/");
      }
    });
  };

  renderProfileModal = () => {
    const { cssfile } = this.props.data;
    return (
      <div
        className={`${cssfile["dropdown"]} ${cssfile["dropdown_myprofile"]}`}
        ref={this.profileRef}
      >
        <div
          className={cssfile["dropdown-item"]}
          onClick={() => this.handleNavigation("/myprofile")}
        >
          <span className={cssfile["dropdown-item-icon"]}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z"
                fill="#003366"
              />
            </svg>
          </span>
          <span className={cssfile["dropdown-item-label"]}>
            {"View Profile"}
          </span>
        </div>
        <div className={cssfile["dropdown-item"]} onClick={this.logOutFun}>
          <span className={cssfile["dropdown-item-icon"]}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z"
                fill="#003366"
              />
            </svg>
          </span>
          <span className={cssfile["dropdown-item-label"]}>{"Logout"}</span>
        </div>
      </div>
    );
  };

  redirectTo = () => {
    window.location.href = this.props?.data?.headermenu?.supportlink;
  };

  render() {
    const { cssfile, user } = this.props.data;
    const filteredItems = this.state.quickLinksDropdownItems.filter((item) => {
      if (user?.user_type !== "ADMIN") {
        return (
          item.code !== "manage_staff" &&
          item.code !== "payment_receipts" &&
          item.code !== "settings" &&
          item.code !== "agency_profile"
        );
      }
      return true;
    });
    const navItems = [
      {
        label: "Home",
        url: "/",
        isDropdown: false,
      },
      {
        label: "Services",
        url: "#",
        isDropdown: true,
        dropdownItems: this.state.servicesDropdownItems,
      },
      {
        label: "Reports",
        url: "/myprofile?activeTab=reports&ReportType=Booking_Reports",
        isDropdown: false,
      },
      {
        label: "Bookings",
        url: "/myprofile?activeTab=mybooking",
        isDropdown: false,
      },
      {
        label: "Clients",
        url: "/myprofile?activeTab=myclients",
        isDropdown: false,
      },
      // {
      //   label: 'Import PNR',
      //   url: '/myprofile?activeTab=importpnr',
      //   isDropdown: false
      // },
      {
        label: "Quick Links",
        url: "#",
        isDropdown: true,
        dropdownItems: filteredItems,
      },
    ];

    return (
      <header
        className={`${cssfile["header"]} ${cssfile["header_sticky"]}`}
        ref={this.ref}
      >
        <div className={cssfile["header__container"]}>
          <div className={cssfile["header__left"]}>
            <img
              src={`/shared/api/media/${this.props?.data?.headermenu?.logo}`}
              alt="Logo"
              className={cssfile["header__logo"]}
              onClick={this.redirectTo}
            />
            <nav className={cssfile["header__nav"]}>
              {navItems.map((item, index) => {
                return (
                  <React.Fragment key={item.label}>
                    {this.renderNavItem(item)}
                    {index + 1 != navItems.length && (
                      <span className={cssfile["header__divider"]}>|</span>
                    )}
                  </React.Fragment>
                );
              })}
            </nav>
          </div>
          <div className={cssfile["header__right"]}>
            <div
              className={cssfile["header__greeting"]}
              onClick={() =>
                this.setState({
                  showProfile: !this.state.showProfile,
                  showBalance: false,
                })
              }
            >
              <span
                className={cssfile["header__username"]}
              >{`Hello, ${commonFunction.toSentenceCase(
                this.props.data.user.first_name
              )} ${commonFunction.toSentenceCase(
                this.props.data.user.last_name
              )}`}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="7"
                viewBox="0 0 11 7"
                fill="none"
              >
                <path
                  d="M0.994842 0.270173L0.0234376 1.24158L5.5116 6.72974L10.9998 1.24158L10.0284 0.270173L5.5116 4.78693L0.994842 0.270173Z"
                  fill="#003366"
                />
              </svg>

              {this.state.showProfile && this.renderProfileModal()}
            </div>
            <div className={cssfile["header__branch"]}>
              <img
                src="/images/branch-icon.svg"
                alt="Branch"
                className={cssfile["header__branch_icon"]}
              />

              <span className={cssfile["header__branch_name"]}>
                {/* {commonFunction.capitalizeEachWord(
                  this.props.data.user.organisation?.name
                )} */}
                {this.props.data.user.organisation?.name}
              </span>
            </div>

            <div
              className={cssfile["header__balance"]}
              onClick={this.handleBalanceModal}
            >
              <span>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.33398 10.5V11.1667V1.83337V10.5ZM1.53915 12.1667C1.20671 12.1667 0.922707 12.049 0.687151 11.8135C0.451707 11.578 0.333984 11.294 0.333984 10.9615V2.03854C0.333984 1.7061 0.451707 1.4221 0.687151 1.18654C0.922707 0.951096 1.20671 0.833374 1.53915 0.833374H10.4622C10.7946 0.833374 11.0786 0.951096 11.3142 1.18654C11.5496 1.4221 11.6673 1.7061 11.6673 2.03854V3.85271H10.6673V2.03854C10.6673 1.97865 10.6481 1.92949 10.6097 1.89104C10.5712 1.8526 10.522 1.83337 10.4622 1.83337H1.53915C1.47926 1.83337 1.4301 1.8526 1.39165 1.89104C1.35321 1.92949 1.33398 1.97865 1.33398 2.03854V10.9615C1.33398 11.0214 1.35321 11.0706 1.39165 11.109C1.4301 11.1475 1.47926 11.1667 1.53915 11.1667H10.4622C10.522 11.1667 10.5712 11.1475 10.6097 11.109C10.6481 11.0706 10.6673 11.0214 10.6673 10.9615V9.14737H11.6673V10.9615C11.6673 11.294 11.5496 11.578 11.3142 11.8135C11.0786 12.049 10.7946 12.1667 10.4622 12.1667H1.53915ZM6.87248 9.50004C6.54004 9.50004 6.25604 9.38232 6.02048 9.14687C5.78504 8.91132 5.66732 8.62732 5.66732 8.29487V4.70521C5.66732 4.37276 5.78504 4.08876 6.02048 3.85321C6.25604 3.61776 6.54004 3.50004 6.87248 3.50004H11.1288C11.4613 3.50004 11.7453 3.61776 11.9808 3.85321C12.2163 4.08876 12.334 4.37276 12.334 4.70521V8.29487C12.334 8.62732 12.2163 8.91132 11.9808 9.14687C11.7453 9.38232 11.4613 9.50004 11.1288 9.50004H6.87248ZM11.1288 8.50004C11.1887 8.50004 11.2379 8.48082 11.2763 8.44237C11.3148 8.40393 11.334 8.35476 11.334 8.29487V4.70521C11.334 4.64532 11.3148 4.59615 11.2763 4.55771C11.2379 4.51926 11.1887 4.50004 11.1288 4.50004H6.87248C6.8126 4.50004 6.76343 4.51926 6.72499 4.55771C6.68654 4.59615 6.66732 4.64532 6.66732 4.70521V8.29487C6.66732 8.35476 6.68654 8.40393 6.72499 8.44237C6.76343 8.48082 6.8126 8.50004 6.87248 8.50004H11.1288ZM8.66732 7.50004C8.9451 7.50004 9.18121 7.40282 9.37565 7.20837C9.5701 7.01393 9.66732 6.77782 9.66732 6.50004C9.66732 6.22226 9.5701 5.98615 9.37565 5.79171C9.18121 5.59726 8.9451 5.50004 8.66732 5.50004C8.38954 5.50004 8.15343 5.59726 7.95898 5.79171C7.76454 5.98615 7.66732 6.22226 7.66732 6.50004C7.66732 6.77782 7.76454 7.01393 7.95898 7.20837C8.15343 7.40282 8.38954 7.50004 8.66732 7.50004Z"
                    fill="#003366"
                  />
                </svg>
              </span>
              <span className={cssfile["header__balance_label"]}>
                {"Available Balance"}
              </span>
              <div className={cssfile["rotate_icon"]}>
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0312 16.75C8.28639 16.75 6.80854 16.1447 5.59771 14.934C4.38674 13.7233 3.78125 12.2457 3.78125 10.5013C3.78125 8.75681 4.38674 7.27882 5.59771 6.06729C6.80854 4.85576 8.28639 4.25 10.0312 4.25C11.0056 4.25 11.9276 4.4666 12.7973 4.89979C13.6669 5.33313 14.3901 5.94451 14.9671 6.73396V4.25H16.2171V9.34604H11.121V8.09625H14.4127C13.9735 7.29167 13.3645 6.65785 12.5856 6.19479C11.8069 5.7316 10.9554 5.5 10.0312 5.5C8.64236 5.5 7.46181 5.98611 6.48958 6.95833C5.51736 7.93056 5.03125 9.11111 5.03125 10.5C5.03125 11.8889 5.51736 13.0694 6.48958 14.0417C7.46181 15.0139 8.64236 15.5 10.0312 15.5C11.1007 15.5 12.066 15.1944 12.9271 14.5833C13.7882 13.9722 14.3924 13.1667 14.7396 12.1667H16.0569C15.6787 13.5267 14.9338 14.6306 13.8221 15.4783C12.7104 16.3261 11.4468 16.75 10.0312 16.75Z"
                    fill="#003366"
                  />
                </svg>
              </div>
              {this.state.showBalance && this.renderBalance()}
            </div>
          </div>
        </div>
      </header>
    );
  }
}
